export const buildBitmovinSource = (url, videoData = {}) => {
  if (!url || typeof url !== 'string') return null;

  const cleanUrl = url.split('?')[0].toLowerCase();
  const source = {
    title: videoData.video_title || videoData.video_name || 'Video',
    poster: videoData.thumbnail_url || '',
    options: {
      adaptation: {
        preload: true
      },
      scaling: {
        fit: 'contain'
      }
    }
  };

  if (cleanUrl.endsWith('.m3u8')) {
    return {
      ...source,
      hls: url
    };
  }

  return {
    ...source,
    progressive: url
  };
};

export const shouldLockPlayerInteractions = ({
  playerInitialized,
  signedVideoUrl,
  sourceLoading
}) => !playerInitialized || !signedVideoUrl || sourceLoading;
